<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'ExpertRessourcesAnimerLaFormation'
});
</script>
<template>
  <ka-container
    code="expert-ressource-6-animation-de-la-format"
    :data="page.$info.expertRessource6AnimationDeLaFormat">
    <!-- Ressources - Experts -->
    <ka-container code="ressources-experts">
      <!-- Titrage -->
      <ka-container code="titrage">
        <ka-text
          code="toutes-les-ressources"
          :options="{
            href: { name: `hub-expert-Ressources` },
            click: page.toutesLesRessourcesClick
          }"
          :xs="{ hidden: null }">
          <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.titrage.toutesLesRessources.value', `< Toutes les ressources`)" />
        </ka-text>
        <ka-text code="animer-la-formation">
          <h1 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.titrage.animerLaFormation.value', `Animer la formation `)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container" />
      </ka-container>
      <!-- Gauche -->
      <ka-container code="gauche">
        <ka-text code="titre">
          <h2 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.titre.value', `Créer un climat de confiance `)" />
        </ka-text>
        <ka-text code="cette-formation-est">
          <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.cetteFormationEst.value', `Cette formation est quelquefois à l’initiative de certains apprenants et un pas vers l’inconnu pour d'autres. En tant qu’expert, vous devez rapidement comprendre <strong>ce que cette formation représente</strong> pour les apprenants et leurs attentes. Les motivations identifiées vous aideront à <strong>orienter la formation</strong> pour qu’elle captive des apprenants à chaque session. `)" />
        </ka-text>
        <!-- Container coach -->
        <ka-container code="container-coach">
          <ka-text code="activites-pour-briser">
            <h3 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.containerCoach.activitesPourBriser.value', `Activités pour briser la glace :`)" />
          </ka-text>
          <ka-text code="le-totem-chaque">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.containerCoach.leTotemChaque.value', `<strong>Le totem</strong> - Chaque stagiaire doit choisir un animal qui le représente et une de ses qualités. Par exemple « Tigre patient ». Ensuite, chacun présente son totem, à commencer par le formateur, de la manière qu’il préfère.<br> <br><strong>L’humeur </strong>- Chaque participant doit envoyer un emoji qui correspond à son humeur dans le chat .<br>Leur choix pourrait être révélateur de leur motivation 😉<br> <br><strong>L'objet perso</strong> - Demandez à chaque participant de sortir les clés de chez lui et de les décrire. Cet exercice permet de s'intéresser à chacun et de sortir du cadre.<br> `)" />
          </ka-text>
        </ka-container>
        <ka-image
          code="image-2"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Image 2`
          }"
          value="https://images.unsplash.com/photo-1587483166702-bf9aa66bd791?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxfHxlbW9qaXxlbnwwfHx8fDE2OTIyODI1NTR8MA&ixlib=rb-4.0.3&q=80&w=1080" />
        <ka-text code="text-1">
          <h2 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.text1.value', `Poser le cadre `)" />
        </ka-text>
        <ka-text code="le-cadre-inclut-votre">
          <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.leCadreInclutVotre.value', `Le cadre inclut votre manière de travailler : <i>respect, échange, écoute</i>. Dans votre présentation vous pouvez par exemple<strong> exposer vos motivations à être formateur occasionnel</strong> en parlant de <strong>vos valeurs</strong>.<br> <br>Le cadre permet également d’instaurer une relation définie avec et entre les apprenants. <strong>Vous allez mener la formation</strong> mais c’est avant tout les apprenants qui vont devoir la nourrir. Grâce à leurs questions et leurs interactions, la formation va s’enrichir. Il est donc essentiel d’instaurer une culture d’échange dès le début de la formation.`)" />
        </ka-text>
        <ka-text code="text-2">
          <h2 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.text2.value', `Instaurer une politique de feedback `)" />
        </ka-text>
        <ka-text code="dans-une-formation">
          <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.dansUneFormation.value', `Dans une formation Matchers, l’expert donne énormément de feedback aux apprenants. Il revient sur les mises en pratique vues ensemble et sur les pratiques déjà en place dans l’entreprise. Pour que le feedback soit utile il faut qu’il soit bien accueilli. La capacité à remettre en question son travail est essentielle pour que les feedbacks contribuent à la productivité. Nous vous recommandons de clarifier ce point avec les apprenants et de toujours agir en fonction des sensibilités de chacun. `)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-1">
          <!-- Container consultant -->
          <ka-container code="container-consultant">
            <ka-text code="les-cles-pour-un-feedback">
              <h3 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.container1.containerConsultant.lesClesPourUnFeedback.value', `Les clés pour un feedback réussi ✅`)" />
            </ka-text>
            <ka-text code="la-bienveillance">
              <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.container1.containerConsultant.laBienveillance.value', `<ul><li>La bienveillance.</li><li>Un retour concentré sur le travail fourni, pas sur une personne.</li><li>Éviter les formules de reproche tournées vers le passé comme “Vous auriez dû”.</li><li>Se concentrer  sur l’avenir avec des phrases comme “Dans les prochaines semaines, vous pourriez”.</li><li>S’émanciper d’un avis subjectif et se baser sur des résultats, des kpi et des constats qui ne pourraient pas être contestés.</li></ul><p> </p><p><span style='background-color:transparent;color:#616161;'><i>Exemple : Au vu du taux d'ouverture de la dernière campagne d’emailing, nous allons évoquer ensemble comment rendre la prochaine plus performante. D’après vous, qu'est ce qui peut influencer l’ouverture d’un mail ? Quels sont donc les éléments à changer dans le prochain envoi ?</i></span></p>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="titre-sadapter-aux-profils-des-apprenant">
          <h2 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.titreSadapterAuxProfilsDesApprenant.value', `S’adapter aux profils des apprenants`)" />
        </ka-text>
        <ka-text code="vous-etes-un-professionnel">
          <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.vousEtesUnProfessionnel.value', `Vous êtes un professionnel, face à des professionnels. Les profils adultes n’apprennent pas dans les mêmes conditions que les enfants. `)" />
        </ka-text>
        <!-- Container exemples -->
        <ka-container code="container-exemples">
          <!-- Container -->
          <ka-container code="container-2">
            <!-- Container -->
            <ka-container code="container-3">
              <ka-text code="text-3">
                <h1 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.containerExemples.container2.container3.text3.value', `Dans une <strong>formation Matchers</strong>, un apprenant assimile de nouvelles compétences s’il :`)" />
              </ka-text>
            </ka-container>
            <ka-text code="adhere-aux-objectifs">
              <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.containerExemples.container2.adhereAuxObjectifs.value', `<ul><li>Adhère aux objectifs pédagogiques ;</li><li>Fait le lien avec son quotidien ;</li><li>Comprend ;</li><li>Agit et met en pratique ;</li><li>A des feedbacks ;</li></ul>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-4">
            <!-- Container -->
            <ka-container code="container-5">
              <ka-text code="contrairement-a-un">
                <h1 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.containerExemples.container4.container5.contrairementAUn.value', `<span style='background-color:transparent;color:#000000;'>Contrairement à un enfant :</span>`)" />
              </ka-text>
            </ka-container>
            <ka-text code="il-attend-un-resultat">
              <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.containerExemples.container4.ilAttendUnResultat.value', `<ul><li>Il attend un résultat concret ;</li><li>Il ne considère pas comme acquise l’autorité du formateur ;</li><li>Il veut que le formateur prenne en considération ses acquis et son expérience ;</li></ul>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="titre-organiser-les-sessions">
          <h2 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.titreOrganiserLesSessions.value', `Organiser les sessions`)" />
        </ka-text>
        <ka-text code="gestion-du-temps">
          <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.GestionDuTemps.value', `<strong>👉  Gestion du temps - </strong>Timer les différentes parties d’une session.<br> <br><strong>👉  Transmission de connaissances -</strong> Dédier un temps au partage de concepts, pratiques théoriques et un temps à la démonstration.<br> <br><strong>👉  Interactivité -</strong> Pousser les apprenants à échanger et partager.<br> <br><strong>👉  Mise en pratique -</strong> La formation doit devenir concrète avec des cas pratiques directement sur le projet en cours dans l’entreprise.<br> <br><strong>👉  Prise de notes</strong> - Les notes et le support de formation peuvent s’additionner pour laisser un contenu complet aux apprenants à l’issue de la formation.`)" />
        </ka-text>
        <ka-text code="titre-sappuyer-sur-le-support">
          <h2 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.titreSappuyerSurLeSupport.value', `S’appuyer sur un support de formation`)" />
        </ka-text>
        <ka-text code="vous-etes-un-professionnel-z-texte">
          <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.vousEtesUnProfessionnelZTexte.value', `Matchers vous propose un <span style='color:#D93174FF;'>support de formation template</span> sur lequel vous pouvez ajouter le contenu de votre formation. Le support de formation permet de captiver l’attention des apprenants et offrir un appui pour guider l’expert durant le partage de connaissance. <br> <br>Le <strong>support de formation</strong> est un outil pendant la transmission d'information mais également lors des mises en pratique. Vous pouvez par exemple l’utiliser pour noter les différentes étapes d’une manipulation afin que les apprenants puissent les retrouver par la suite. Pour autant, <strong>le support de formation</strong> ne doit pas occuper tout l’espace d’une session. Il doit laisser place à de la mise en pratique. Durant la mise en pratique il peut être utile pour reporter les informations abordées. `)" />
        </ka-text>
        <BlocPreviewRessourceSansDescription
          instance-class="preview-ressource-short--p121"
          :options="{
            href: { name: `hub-expert-Ressources-construire-support-de-formation` },
            click: page.previewRessourceShortClick
          }"
          :title="page.$constants.previewRessourceShortTitle"
          image="https://ucarecdn.com/54d9450f-59e7-4d48-a950-6e6937b093f3/" />
        <ka-text code="text-4">
          <h2 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.text4.value', `Outils pour animer la formation `)" />
        </ka-text>
        <!-- Container exemples -->
        <ka-container code="container-6">
          <!-- Container -->
          <ka-container code="container-7">
            <!-- Container -->
            <ka-container code="container-8">
              <ka-text code="a-lechelle-de-la-formation">
                <h1 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.container6.container7.container8.aLechelleDeLaFormation.value', `À l'échelle de la formation`)" />
              </ka-text>
            </ka-container>
            <ka-text code="google-slides">
              <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.container6.container7.googleSlides.value', `<span style='background-color:transparent;color:#000000;'><strong>Google Slides : </strong>Matchers met à disposition un template de diaporama. Il s'agit d'un outil de présentation indispensable. </span><br> <br><span style='background-color:transparent;color:#000000;'><strong>Trello </strong>est<strong> </strong></span>outil de gestion de tâches. Il permet d'avoir une vue d'ensemble sur l'organisation et  le suivi de projets en cartes et listes.<br> <br><span style='background-color:transparent;color:#000000;'><strong>Miro</strong> est une plateforme collaborative visuelle qui permet de créer des cartes mentales. Avec cet outil vous pouvez permettre aux apprenants de collaborer pour organiser leurs idées. <i>(Accessible à partir de l'outil de visio google meet) </i></span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-9">
            <!-- Container -->
            <ka-container code="container-10">
              <ka-text code="pendant-une-session">
                <h1 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.container6.container9.container10.pendantUneSession.value', `Pendant une session`)" />
              </ka-text>
            </ka-container>
            <ka-text code="google-meet-outils">
              <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.container6.container9.googleMeetOutils.value', `<span style='background-color:transparent;color:#000000;'><strong>Google meet : </strong>Outils disponibles durant la visio (Sondage, tableau blanc avec post-it)</span><br> <br><span style='background-color:transparent;color:#000000;'><strong>Kahoot </strong>permet de créer un quizz en ligne qui met en concurrence les différents participants : ils gagnent des points pour chaque réponse correcte et sont classés en fonction de leur score total.</span><br> <br><strong>Wooclap</strong> est un outil interactif qui permet de créer des sondages interactifs, quiz stimulants, interactions en temps réel. `)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="text-5">
          <h2 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.text5.value', `Découper les sessions en plusieurs temps`)" />
        </ka-text>
        <ka-image
          code="image-4"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image 4`
          }"
          value="https://ucarecdn.com/18daafd3-b43c-4807-84e9-390629db92d7/" />
        <!-- Container exemples -->
        <ka-container code="container-11">
          <!-- Container -->
          <ka-container code="container-12">
            <ka-image
              code="image-3"
              :options="{
                animationIn: `fadeIn`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                imgFit: `cover`,
                imgText: ``,
                alt: `Image 3`
              }"
              value="https://images.unsplash.com/photo-1524678606370-a47ad25cb82a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHw1fHxsaXN0ZW58ZW58MHx8fHwxNjkyMzY4MTg3fDA&ixlib=rb-4.0.3&q=80&w=1080" />
            <ka-text code="partie-1-moment">
              <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.container11.container12.partie1Moment.value', `<span style='color:#1100A2FF;'><strong>Partie 1 : </strong>Moment de constat et de questionnement pour faire l'état des lieux de l'existant et / ou du travail fourni depuis la dernière session. </span><br> <br><strong>👉   L’écoute</strong> vous aide à comprendre l’apprenant pour mieux faire passer les messages que vous souhaitez.<br> <br><strong>👉   La reformulation</strong> vous permet de clarifier et de vous assurer que vous avez bien compris votre interlocuteur. Elle donne aussi l’assurance à l’apprenant que son point de vue est bien compris.<br> <br><strong>👉   Les questions</strong> ont pour objectif d’aider les stagiaires à réfléchir et à entamer la discussion sur un sujet lié à la thématique de la formation.`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-13">
            <ka-image
              code="image-1"
              :options="{
                animationIn: `fadeIn`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                imgFit: `cover`,
                imgText: ``,
                alt: `Image 3`
              }"
              value="https://ucarecdn.com/a2a44513-0560-4647-bf8d-08185038c949/" />
            <ka-text code="partie-2-un">
              <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.container11.container13.partie2Un.value', `<span style='color:#1100A2FF;'><strong>Partie 2 : </strong></span><span style='background-color:transparent;color:#1100A2FF;'>Un temps ou vous animez en partageant vos connaissances et vos bonnes pratiques avec le support de formation.</span><br> <br><strong>👉   L'explication</strong> permet de décomposer des concepts complexes en éléments compréhensibles. Lorsque vous expliquez, assurez-vous de prendre en compte le niveau de connaissance de votre auditoire.<br> <br><strong>👉   La démonstration </strong>vous permet de concrétiser la théorie en actions concrètes. Veillez à encourager les questions et la participation pendant la démonstration pour créer un environnement interactif.`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-14">
            <ka-image
              code="image-5"
              :options="{
                animationIn: `fadeIn`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                imgFit: `cover`,
                imgText: ``,
                alt: `Image 3`
              }"
              value="https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxM3x8d29ya3xlbnwwfHx8fDE2OTIzNjgxNjR8MA&ixlib=rb-4.0.3&q=80&w=1080" />
            <ka-text code="partie-3-dediee">
              <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.container11.container14.partie3Dediee.value', `<span style='color:#1100A2FF;'><strong>Partie 3 : </strong>Dédiée à la mise en pratique par les apprenants, l'expert continue de partager ses connaissances à travers un cas concret, celui de l'entreprise. </span><br> <br><strong>👉   L'observation</strong> aide à repérer les difficultés auxquelles les apprenants sont confrontés. En étant attentif à leurs actions, vous pouvez ajuster votre approche en temps réel, fournir des conseils précis et anticiper les points de blocage potentiels.<br> <br><strong>👉   Les feedbacks</strong>, quant à eux, permettent aux participants de progresser et de prendre conscience de leurs forces et faiblesses. `)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="text-6">
          <h2 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.text6.value', `En savoir + sur les différents types d'apprentissage`)" />
        </ka-text>
        <!-- Conteneur question -->
        <ka-container code="conteneur-question">
          <!-- Deroulent -->
          <ka-container
            code="deroulent"
            :options="{
              click: page.deroulentClick,
              $state: { selected: $isEqual(page.$elements['question-1']?.style.hidden, page.$constants.question1Hidden) }
            }"
            :selected="{ click: page.deroulentClickWhenSelected }">
            <!-- placement -->
            <ka-container code="placement">
              <ka-text code="les-7-differents-types">
                <h3 v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.deroulent.placement.les7DifferentsTypes.value', `Les 7 différents types d'apprentissages`)" />
              </ka-text>
            </ka-container>
            <ka-icon
              code="icone-developper-4"
              :options="{ $inheritState: { selected: true } }"
              value="i-fa-solid:angle-down" />
          </ka-container>
          <!-- Question 1 -->
          <ka-container
            code="question-1"
            :options="{
              animationIn: `fadeIn`,
              hidden: null
            }">
            <!-- Container exemples -->
            <ka-container code="container-15">
              <!-- Container -->
              <ka-container code="container-16">
                <!-- Container -->
                <ka-container code="container-17">
                  <ka-text code="apprentissage-par">
                    <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container16.container17.apprentissagePar.value', `<span style='background-color:transparent;color:#000000;'><strong>Apprentissage par imitation</strong></span>`)" />
                  </ka-text>
                </ka-container>
                <ka-text code="verbe-connaissance">
                  <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container16.verbeConnaissance.value', `C’est l’apprentissage le plus courant : il suppose de la part de l’enfant (ou de l’adulte dans certaines situations) la valorisation d’un modèle et la volonté de le posséder, de le prendre comme modèle. C’est par l’imitation que se font tous les apprentissages spontanés de la petite enfance : parole, gestes, mimiques, etc.., ainsi que ceux de la dimension esthétique des activités : ton, grâce, style, manière, etc.`)" />
                </ka-text>
              </ka-container>
              <!-- Container -->
              <ka-container code="container-18">
                <!-- Container -->
                <ka-container code="container-19">
                  <ka-text code="text-7">
                    <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container18.container19.text7.value', `<span style='background-color:transparent;color:#000000;'><strong>Apprentissage par répétition</strong></span>`)" />
                  </ka-text>
                </ka-container>
                <ka-text code="on-fait-faire-au-sujet">
                  <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container18.onFaitFaireAuSujet.value', `On fait faire au sujet ce qu’il doit apprendre, d’abord passivement, puis de plus en plus activement, jusqu’à ce qu’il puisse faire et refaire seul les opérations. L'idée est d'automatiser l'apprentissage en faisant des kilomètres d'exercice. C'est proche des principes du béhavorisme qui segmente les apprentissages, systématise et conduit l'apprenant du simple au plus compliqué. On apprend ainsi le code de la route, le calcul mental, la division...`)" />
                </ka-text>
              </ka-container>
              <!-- Container -->
              <ka-container code="container-20">
                <!-- Container -->
                <ka-container code="container-21">
                  <ka-text code="text-8">
                    <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container20.container21.text8.value', `<span style='background-color:transparent;color:#000000;'><strong>Apprentissage par association</strong></span>`)" />
                  </ka-text>
                </ka-container>
                <ka-text code="on-associe-un-stimulus">
                  <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container20.onAssocieUnStimulus.value', `On associe un stimulus nouveau à un mécanisme déjà appris afin de créer un nouveau savoir. Pour apprendre des choses complexes, cela permet d’enchaîner des situations de difficulté croissante. C'est le principe du béhaviorisme. `)" />
                </ka-text>
              </ka-container>
              <!-- Container -->
              <ka-container code="container-22">
                <!-- Container -->
                <ka-container code="container-23">
                  <ka-text code="text-9">
                    <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container22.container23.text9.value', `<span style='background-color:transparent;color:#000000;'><strong>Apprentissage par essais et erreurs</strong></span>`)" />
                  </ka-text>
                </ka-container>
                <ka-text code="le-sujet-est-mis-en">
                  <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container22.leSujetEstMisEn.value', `Le sujet est mis en situation d’essai, on ne lui donne aucun mode d’emploi (parfois même pas la condition de succès ou d’élimination). Pour fonctionner correctement, il faut que la solution prenne en compte ce que le sujet sait déjà. Ce modèle est celui du constructivisme. Le formateur est facilitateur : il régule, il étaye...`)" />
                </ka-text>
              </ka-container>
              <!-- Container -->
              <ka-container code="container-24">
                <!-- Container -->
                <ka-container code="container-25">
                  <ka-text code="text-10">
                    <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container24.container25.text10.value', `<span style='background-color:transparent;color:#000000;'><strong>Apprentissage par explication</strong></span>`)" />
                  </ka-text>
                </ka-container>
                <ka-text code="on-explique-au-sujet">
                  <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container24.onExpliqueAuSujet.value', `On explique au sujet, oralement ou par écrit, ce qu’il doit savoir (exemple : un manuel de secourisme). C’est le principe des cours magistraux, ou du cours dialogué. Le formateur est dans une posture expositive.`)" />
                </ka-text>
              </ka-container>
              <!-- Container -->
              <ka-container code="container-26">
                <!-- Container -->
                <ka-container code="container-27">
                  <ka-text code="text-11">
                    <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container26.container27.text11.value', `<span style='background-color:transparent;color:#000000;'><strong>Apprentissage par immersion</strong></span>`)" />
                  </ka-text>
                </ka-container>
                <ka-text code="les-langues-sapprennent">
                  <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.container26.lesLanguesSapprennent.value', `<span style='background-color:transparent;color:#000000;'>Les langues s’apprennent mieux en situation d’immersion totale. Par exemple, lorsque les cours ne sont donnés que dans la langue à apprendre et que le professeur ne parle avec les élèves que dans leur langue d’immersion.</span>`)" />
                </ka-text>
              </ka-container>
              <ka-text code="text-12">
                <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.gauche.conteneurQuestion.question1.container15.text12.value', `<span style='color:#1100A2FF;'><strong>Apprentissage combiné : </strong></span><br><span style='color:#1100A2FF;'>Il est très efficace en matière d’enseignement de savoir-faire professionnel, car il combine les modalités précédentes. Le sujet est mis en situation : on lui montre quelquefois les bons gestes en lui expliquant les principes d’action. On le laisse ensuite se perfectionner par une répétition de moins en moins supervisée.</span>`)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Droite -->
      <ka-container code="droite">
        <!-- Container -->
        <ka-container
          code="container-28"
          :xs="{ hidden: null }">
          <ka-text code="text-13">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container28.text13.value', `<strong>Sommaire :</strong>`)" />
          </ka-text>
          <ka-text code="text-14">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container28.text14.value', `<ul><li>Créer un climat de confiance</li></ul>`)" />
          </ka-text>
          <ka-text code="text-15">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container28.text15.value', `<ul><li>Poser le cadre</li></ul>`)" />
          </ka-text>
          <ka-text code="text-16">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container28.text16.value', `<ul><li>S'adapter aux profils des apprenants</li></ul>`)" />
          </ka-text>
          <ka-text code="text-17">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container28.text17.value', `<ul><li>Instaurer une politique de feedback </li></ul>`)" />
          </ka-text>
          <ka-text code="text-18">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container28.text18.value', `<ul><li>Organiser les sessions</li></ul>`)" />
          </ka-text>
          <ka-text code="text-19">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container28.text19.value', `<ul><li>S'appuyer sur un support de formation</li></ul>`)" />
          </ka-text>
          <ka-text code="text-20">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container28.text20.value', `<ul><li>Créer et encourager les intéractions</li></ul>`)" />
          </ka-text>
          <ka-text code="text-21">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container28.text21.value', `<ul><li>Découper les sessions en plusieurs temps</li></ul>`)" />
          </ka-text>
          <ka-text code="text-22">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container28.text22.value', `<ul><li>En savoir + sur les différents types d'apprentissage</li></ul>`)" />
          </ka-text>
        </ka-container>
        <!-- Container 2 -->
        <ka-container code="container-29">
          <ka-text code="text-23">
            <span v-html="t('expertRessource6AnimationDeLaFormat.ressourcesExperts.droite.container29.text23.value', `Autres ressources disponibles :`)" />
          </ka-text>
          <BlocPreviewRessourceSansDescription
            instance-class="element-1--p121"
            :options="{
              href: { name: `Expert-Ressources-posture-du-formateur` },
              click: page.element1Click
            }"
            title="<strong>Quel est la posture de l'expert Matchers ? </strong>"
            image="https://images.unsplash.com/photo-1584462746497-276f4aeb9fca?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwzMHx8YmFja3xlbnwwfHx8fDE2OTIyODcxNDF8MA&ixlib=rb-4.0.3&q=80&w=1080" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-2--p121"
            :options="{
              href: { name: `hub-expert-Ressources-construire-support-de-formation` },
              click: page.element2Click
            }"
            title="<strong>Comment rédiger mon support de formation ?</strong>"
            image="https://ucarecdn.com/a2a44513-0560-4647-bf8d-08185038c949/" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-3--p121"
            :options="{
              href: { name: `hub-expert-Ressources-preparer-rdv-decouverte` },
              click: page.element3Click
            }" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-4--p121"
            :options="{
              href: { name: `hub-expert-Ressources-rediger-programme-de-formation` },
              click: page.element4Click
            }"
            title="<strong>Comment rédiger un programme de formation ?</strong>"
            image="https://ucarecdn.com/d94a0c66-9322-47b8-afc4-5d0d564e6da8/" />
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { expertRessourcesAnimerLaFormation } from './store'
import BlocPreviewRessourceSansDescription from '~/components/BlocPreviewRessourceSansDescription/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p121')
const appData = appDataStore()
const page = expertRessourcesAnimerLaFormation()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
